import { EditorState, Modifier } from "draft-js";

import EntityTypeIdentifiers from "../EntityTypeIdentifiers";

/**
 * @param {EditorState}    editorState
 * @param {SelectionState} mentionSelection
 * @param {String}         displayText
 * @param {?Object}        data
 * @param {String}         mutability
 * @param {EditorState}
 */
export default function insertMentionEntity(
  editorState,
  mentionSelection,
  displayText,
  data,
  mutability = "SEGMENTED",
) {
  const originalContent = editorState.getCurrentContent();
  const contentStateWithMention = originalContent.createEntity(
    EntityTypeIdentifiers.MENTION,
    mutability,
    data,
  );

  const replacedContent = Modifier.replaceText(
    editorState.getCurrentContent(),
    mentionSelection,
    displayText,
    null,
    contentStateWithMention.getLastCreatedEntityKey(),
  );

  return EditorState.push(editorState, replacedContent, "apply-entity");
}
